import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import styles from './SortingFacet.module.scss';
import { RightArrow } from '../../../../../lib/icons/RightArrow';
import { Label } from '../../../../common/Label/Label';
import { FILTER_LABELS, SORT } from '../../../../../lib/constants/labelKeys';
import { sortToStringValues, stringToSortValues } from './SortingFacet.utils';
import { FilterSortBy } from '../../../../../lib/utils/search/searchModel';
import { SORT_DIRECTION_OPTIONS } from '../../../../../lib/utils/search/searchHelper';
import { CY_SEARCH_AND_SORT } from '../../../../../lib/constants/cypress';
import { Api } from '../../../../../lib/types/apiSpec';

export type SortingFacetProps = {
  sortBy: FilterSortBy;
  sortDirection: Api.SortDirection;
  onChange: (sortBy: FilterSortBy, direction: Api.SortDirection) => void;
  sortByOptions: FilterSortBy[];
};

const getDirectionLabel = (direction: Api.SortDirection): string => {
  const directionLabels = {
    asc: SORT.ASC,
    desc: SORT.DESC,
  };

  return directionLabels[direction];
};

const SortingFacet = ({ sortBy, sortDirection, onChange, sortByOptions }: SortingFacetProps) => {
  const value = sortToStringValues(sortBy, sortDirection);
  const handleSelect = (event: SelectChangeEvent) => {
    const newValue = stringToSortValues(event.target.value);

    if (newValue.toString() !== value.toString()) {
      onChange(...stringToSortValues(event.target.value));
    }
  };

  const menuItems = sortByOptions.flatMap(sortByItem =>
    SORT_DIRECTION_OPTIONS.map(sortDirectionItem => (
      <MenuItem
        className={styles.menuItem}
        value={sortToStringValues(sortByItem, sortDirectionItem)}
        key={`${sortByItem}-${sortDirectionItem}`}
      >
        <Label name={FILTER_LABELS.SORT_BY_FACET_VALUES_LABEL(sortByItem)} />
        &nbsp;
        <Label name={getDirectionLabel(sortDirectionItem)} />
      </MenuItem>
    )),
  );

  return (
    <div className={styles.sortByContainer}>
      <div className={styles.sortByLabel}>
        <Label name={FILTER_LABELS.FACET_LABEL('sort')} />
      </div>

      <Select
        classes={{ select: styles.selectInput, root: styles.inputRoot, icon: styles.icon, iconOpen: styles.iconOpen }}
        data-cy={CY_SEARCH_AND_SORT.SORT_SELECTOR}
        value={value}
        IconComponent={RightArrow}
        onChange={handleSelect}
      >
        {menuItems}
      </Select>
    </div>
  );
};

export default SortingFacet;
